import { HttpErrorResponse } from '@angular/common/http';

import { RejectionReport } from '../../entities/downloads/rejection-report-request.entity';

export type ReportFailureCase = 'too-large' | 'rest';

const TOO_LARGE_PREFIXES: readonly RegExp[] = [
    /The selection is too large for a rejection report/i,
    /The selection holds more than/i,
    /This selection is too broad for one rejection report/i
];

const FILENAME_PREFIX: RegExp = /^(\d{14})/;

export function toRejectionReport(csv: string): RejectionReport {
    const endings: number = (csv.match(/\n/g) ?? []).length;

    if (endings === 0) {
        throw new Error('The rejection report holds no line ending, so it is not a csv.');
    }

    return { csv, hasRejections: endings > 1 };
}

export function classifyReportFailure(error: unknown): ReportFailureCase {
    if (!(error instanceof HttpErrorResponse) || error.status !== 400) {
        return 'rest';
    }

    const message: string = typeof error.error?.Message === 'string' ? error.error.Message : '';

    return TOO_LARGE_PREFIXES.some(prefix => prefix.test(message)) ? 'too-large' : 'rest';
}

/** The moment as `yyyyMMddHHmmss` in UTC, the same shape as the instant that leads an export name. */
export function toReportStamp(epochMs: number): string {
    return new Date(epochMs).toISOString().replace(/\D/g, '').slice(0, 14);
}

export function toReportFilename(firstJobName: string | undefined): string {
    const prefix: RegExpExecArray | null = FILENAME_PREFIX.exec(firstJobName ?? '');

    return prefix ? `fouten-${prefix[1]}.csv` : 'fouten.csv';
}
